export const chekout = {
  path: "/checkout",
  name: "checkout",
  hidden: true,
  component: () => import("@/components/buyMedicine/components/checkout"),
  meta: {
    title: "Pembayaran",
    icon: "fa-capsules",
    roles: ["administrator", "member"]
  }
};
export default chekout;



// WEBPACK FOOTER //
// ./src/router/modules/checkout.js